<template>
  <v-dialog v-model="open" max-width="500px" :scrollable="true" @update:model-value="openChange" v-on:keydown.stop.esc="onClose">
    <template v-slot:activator="{ props }">
      <v-list-item v-bind="props">
        <v-list-item-title>Export to Jira</v-list-item-title>
      </v-list-item>
    </template>
    <template #default>
      <v-card :flat="true">
        <v-toolbar density="compact" color="white">
          <v-toolbar-title v-if="jiraProject">Transfer Cards to Jira</v-toolbar-title>
          <v-toolbar-title v-else>Map your Continuum Design project to a Jira project</v-toolbar-title>
          <v-btn icon @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p class="mb-0" v-if="jiraProject">
            This project is already mapped to a Jira project. Login to your Jira Cloud workspace, select your Jira project and then select the Continuum Design app from the left navigation menu to import the cards you created in Continuum Design.
          </p>
          <p class="mb-0" v-else>
            If you haven't done it already, please install the Continuum Design app from the Atlassian Marketplace. Then login to Continuum Design from Jira and map your Continuum Design project to your Jira project by following the instructions in Jira.
          </p>
          <p>&nbsp;</p>
          <p><a href="https://marketplace.atlassian.com/apps/1229550/qlerify-process-and-data-modeler?hosting=cloud&tab=overview" target="_blank">Link to our Atlassian Marketplace App Here</a></p>
          <p>&nbsp;</p>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      open: false,
      selected: [],
      exporting: false,
      jiraProject: false
    }
  },

  computed: {
    ...mapGetters({
      project: 'projectMemberships/activeProject'
    })
  },

  methods: {
    openChange (open) {
      if (!open) {
        this.onClose()
      }
    },

    onClose () {
      this.selected = []
      this.open = false
      this.exporting = false
    }
  },
  async created () {
    this.jiraProject = this.project?.jiraForgeData?.projectId
  }
}
</script>
